module.exports = __webpack_public_path__ + "static/img/内资公司工会法人变更登记一件事.dd81e69.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/内资公司工会法人变更登记一件事.png
// module id = +Yd4
// module chunks = 2